import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import Analytics from "../../../../analytics";

export default class MobileNavigationAllWallsCheckbox extends Component {

  static propTypes = {
    parentNavigationItem: PropTypes.instanceOf(DesignNavigationItem).isRequired,
    toggleApplyWallsCheckbox: PropTypes.func.isRequired,
  };

  allWallsClick = () => {
    Analytics.sendClickEvent('all-walls-toggled');
    this.props.toggleApplyWallsCheckbox();
    setTimeout(() => {
      this.forceUpdate();
    }, 0)
  };

  render() {
    return (
      <button className="ui-checkbox-wrapper" onClick={this.allWallsClick}>
        <span className={"ui-checkbox" + (this.props.parentNavigationItem.part.allWallsApplied ? " ui-checkbox--checked" : "")}/>
        <span className="ui-checkbox__label">
          <FormattedMessage id="radioButtonAllWalls1"/> <br/><FormattedMessage id="radioButtonAllWalls2"/>
        </span>
      </button>
    )
  }
}
